import React from "react";
import "../styles/SectionDivider.css";
import sectionDivider from "../images/section-divider.svg";
import airplane from "../images/airplane.svg";

const SectionDivider = () => {
  return (
    <div>
      <img
        className="section-divider-style"
        src={sectionDivider}
        alt="section divider"
        loading="eager"
      />
    </div>
  );
};

export default SectionDivider;
